import { ViewModelClientError } from '@engoo/view-model';
import { CLIENT_VERSION } from 'app/constants/PageMetaTags';
import { containsSchemaMismatch } from 'app/remote/error';
import { getMetaTag } from 'app/utils/env';
import appConfig from 'app/config/client';
import { breakingChangeTimestamp } from 'config/version';

/**
 * Given a version number, creates the content that is expected in the client version file.
 *
 * @param {String} version      hash key for the version
 * @returns {String}
 */
export const buildVersionFileContent = ({ version, release }) =>
  JSON.stringify({ version, breakingChangeTimestamp, release });

export const getClientVersionField = versionFileJSON => versionFileJSON.version;

export const getBreakingChangeTimestamp =
  versionFileJSON => versionFileJSON.breakingChangeTimestamp;

/**
 * @param {Document|HtmlElement} root
 * @returns {String}
 */
export const getLocalClientVersion = () => getMetaTag(CLIENT_VERSION);

export const getLocalBreakingChangeTimestamp = () => breakingChangeTimestamp;

/**
 * Determines whether an error merits checking if the client version is outdated.
 *
 * @param {Error} error
 * @returns {Boolean}
 */
export const requiresClientVersionCheck = (error) =>
  error instanceof ViewModelClientError || containsSchemaMismatch(error);

// Use the date of the deploy time as the "release" identifier.
export const getLocalClientRelease = () => appConfig.deployInfo.date;
